import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=cd2e487e&scoped=true&"
import script from "./sent.vue?vue&type=script&lang=js&"
export * from "./sent.vue?vue&type=script&lang=js&"
import style0 from "./sent.vue?vue&type=style&index=0&id=cd2e487e&prod&lang=less&scoped=true&"
import style1 from "./sent.vue?vue&type=style&index=1&id=cd2e487e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2e487e",
  null
  
)

export default component.exports